import Form from "@/app/components/UI/Form";
import Head from "next/head";

export default function ContactPage() {
	return (
		<>
			<Head>
				<title>Azul Agro - Atendimento</title>
				<meta
					name="description"
					content="Entre em contato com a Azul Agro para tirar suas dúvidas, solicitar informações sobre nossos produtos ou receber suporte técnico. Estamos prontos para ajudar você a otimizar suas operações agrícolas com nossas soluções de alta performance."
				/>
			</Head>
			<main>
				<Form />
			</main>
		</>
	);
}
